export default {
  setRawSpec (state, {key, value}) {
    state.rawSpec[key] = value
  },
  setAlgoId (state, value) {
    state.algoId = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/smartRawMapping/mutations.js